import FileUpload from './FileUpload.view';

export default FileUpload;
